module.exports = __webpack_public_path__ + "static/img/14000696.c93cdb4e.png";